import RoomLayout from "/components/shared/layouts/RoomLayout";
import RoomBox from "/components/shared/layouts/RoomBox";
import ViewHeader from "/components/shared/ViewHeader.jsx";

export default function Impressum() {

    return (
        <RoomLayout key="room" background="bg-cover bg-foyerBlurred">
          <RoomBox style='mt-24 p-4'>
            <ViewHeader title="zum foyer" url="/foyer"/>
            <div className='text-sm xl:text-base mt-6 flex items-center justify-center'>
              <p>
                <h1 className='mr-2'>IMPRESSUM</h1>
                <br/>
                Angaben gemäß § 5 TMG

                <br/><br/>

                Junges Theater Bonn e.V.

                <br/><br/>

                Hermannstr. 50 <br/>

                D - 53225 Bonn-Beuel <br/>

                Tel. (0228) 46 36 72 <br/>

                Fax (0228) 69 60 07 <br/>

                <br/><br/>

                Vereinsregister AG Bonn VR 3439 <br/>

                Finanzamt Bonn-Außenstadt 5206/5867/0258 <br/>

                <br/><br/>

                Intendanz: Moritz Seibert (Geschäftsführer und Verantwortlich für den Inhalt nach § 55
                Abs. 2 RStV)
                <br/><br/>
                Vorstand:<br/>

                Hannelore Ueberholz (Vorsitzende)<br/>

                Martin Sonnert (Schriftführer)<br/>

                Uwe Kaspers (Kassenwart)<br/>

              </p>
            </div>
          </RoomBox>
        </RoomLayout>
    );
}


